import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const resourceReqBaseUrl = '/api/resource-requests';
export const resourceReqApi = createApi({
  reducerPath: 'resourceReqApi',
  baseQuery: customBaseQuery,
  tagTypes: ['ResourceRequest', 'ResourceRequestList'],
  endpoints: (builder) => ({
    allResourceRequests: builder.query<ResourceRequestsTableResponse, ResourceRequestSearchParams>({
      query: (params) => ({
        url: resourceReqBaseUrl,
        params,
      }),
      providesTags: ['ResourceRequestList'],
    }),
    getOneResReq: builder.query<IResourceRequest, GetOneResourceRequestPayload>({
      query: ({ id, accessToken }) => ({
        url: `${resourceReqBaseUrl}/${id}`,
        params: accessToken ? { access_token: accessToken } : undefined,
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'ResourceRequest', id }],
    }),
    createResourceRequest: builder.mutation<IResourceRequest, ResourceRequestPostPayload>({
      query: (payload) => ({
        url: resourceReqBaseUrl,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ResourceRequestList'],
    }),
    updateResourceRequest: builder.mutation<IResourceRequest, ResourceRequestPostPayload>({
      query: (payload) => ({
        url: `${resourceReqBaseUrl}/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (_result, _error, payload) => [
        'ResourceRequestList',
        { type: 'ResourceRequest', id: payload.id ?? undefined },
      ],
    }),
    createResourceRequestFulfillment: builder.mutation<
      IResourceRequestFulfill,
      ResourceRequestFulfillmentPayload
    >({
      query: (payload) => ({
        url: `${resourceReqBaseUrl}/fulfillment`,
        method: 'POST',
        body: payload,
        params: payload.accessToken ? { access_token: payload.accessToken } : undefined,
      }),
      invalidatesTags: (_result, _error, payload) => [
        { type: 'ResourceRequest', id: payload.requestId },
      ],
    }),
    updateResourceRequestFulfillment: builder.mutation<
      IResourceRequestFulfill,
      UpdateResReqFulfillmentPayload
    >({
      query: (payload) => ({
        url: `${resourceReqBaseUrl}/fulfillment/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['ResourceRequestList'],
    }),
  }),
});

export const {
  useAllResourceRequestsQuery,
  useGetOneResReqQuery,
  useCreateResourceRequestMutation,
  useCreateResourceRequestFulfillmentMutation,
  useUpdateResourceRequestMutation,
  useUpdateResourceRequestFulfillmentMutation,
} = resourceReqApi;
